module.exports = __webpack_public_path__ + "static/img/logo3.2b767b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/logo3.png
// module id = L2GP
// module chunks = 26